var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgApps = function SvgApps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 19,
    fill: "none",
    viewBox: "0 0 18 19"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 6.12,
    height: 6.12,
    x: 10.19,
    y: 10.95,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12,
    height: 6.12,
    x: 1,
    y: 1.77,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6.12,
    height: 6.12,
    x: 1,
    y: 10.95,
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    rx: 1,
    vectorEffect: "non-scaling-stroke"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9.68 4.54h7.07M13.46 8.32V1.25",
    vectorEffect: "non-scaling-stroke"
  })));
};
export default SvgApps;